import { PayloadAction } from "@reduxjs/toolkit";
import { PHARMACY_USER_TYPE } from "@/redux/slice/auth/enums/PharmacyUserType";
import { SignedinState } from "@/redux/slice/auth/enums/SignedInState";
import { AuthState } from "@/redux/slice/auth/types/AuthState";
import patientDetailsAdapter from "@/redux/slice/auth/adapter/patientDetails";
import { Patient } from "@/redux/slice/auth/types/Patient";

const AuthReducer = {
  updateSSOToken(state: AuthState, action: PayloadAction<string>) {
    state.ssoToken = action.payload;
  },
  updateAuthToken(state: AuthState, action: PayloadAction<string>) {
    state.authToken = action.payload;
  },
  updateCurrentPatientId(state: AuthState, action: PayloadAction<string>) {
    state.currentPatientId = action.payload;
  },
  updateAskForConsent(state: AuthState, action: PayloadAction<boolean>) {
    state.askForConsent = action.payload;
  },
  updateUserConsent(state: AuthState, action: PayloadAction<boolean>) {
    state.userConsent = action.payload;
  },
  updateSignedInState(state: AuthState, action: PayloadAction<SignedinState>) {
    state.signedInStatus = action.payload;
  },
  updateSignInError(state: AuthState, action: PayloadAction<boolean>) {
    state.signInError = action.payload;
  },
  updateUserType(state: AuthState, action: PayloadAction<PHARMACY_USER_TYPE>) {
    state.userType = action.payload;
  },
  updateNewUser(state: AuthState, action: PayloadAction<boolean>) {
    state.newUser = action.payload;
  },
  updateTokenRefresh(state: AuthState, action: PayloadAction<boolean>) {
    state.tokenRefresh = action.payload;
  },
  updateTokenRecievedFetchPatients(state: AuthState, action: PayloadAction<boolean>) {
    state.tokenRecievedFetchPatients = action.payload;
  },
  updatePatientList(state: AuthState, action: PayloadAction<Patient[]>) {
    patientDetailsAdapter.setAll(state.patientDetails, action.payload);
  },
  updateCurrentPatient(state: AuthState, action: PayloadAction<Patient>) {
    patientDetailsAdapter.setOne(state.patientDetails, action.payload);
  },
  updateMiniAppSSOErrorCode(state: AuthState, action: PayloadAction<number>) {
    state.miniAppErrorCode = action.payload;
  },
  updateUserCorporateTag(state: AuthState, action: PayloadAction<string>) {
    state.corporateTag = action.payload;
  },
  updateUserOnboarded(state: AuthState, action: PayloadAction<boolean>) {
    state.userOnboarded = action?.payload;
  },
  handleOpenLoginModal(state: AuthState, action: PayloadAction<boolean>) {
    state.openLoginModal = action?.payload;
  },
  handleSegmentInfo(state: AuthState, action: PayloadAction<boolean>) {
    state.segmentInfo = action?.payload;
  },
};

export default AuthReducer;
